<mat-card class="cur-card">
  <mat-card-header>
    <mat-card-title>検索結果</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div class="table-responsive" style="max-height: 500px; overflow: auto;">
      <table mat-table [dataSource]="dataSource" matSort style="min-width: 1550px;" #sort1="matSort">
        <ng-container matColumnDef="claimYmt">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 75px;">
            請求年月</th>
          <td mat-cell *matCellDef="let row">{{row.claimYmt | dateYmStringSg}}
          </td>
        </ng-container>
        <ng-container matColumnDef="payDlineYearmonthdate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 105px;">
            支払期限年月日</th>
          <td mat-cell *matCellDef="let row">{{row.payDlineYearmonthdate | dateString}} </td>
        </ng-container>
        <ng-container matColumnDef="payCtrNo">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 120px;">
            支払契約番号</th>
          <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
        </ng-container>
        <ng-container matColumnDef="visitName">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 85px;">
            請求先名</th>
          <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
        </ng-container>
        <ng-container matColumnDef="supplystopBreakscheduleAchievymd">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 130px;">
            供給停止・解約<br>予定（実績）年月日</th>
          <td mat-cell *matCellDef="let row">{{row.supplystopBreakscheduleAchievymd | dateString}} </td>
        </ng-container>
        <ng-container matColumnDef="pressmanagementdivisionAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 90px;">
            督促管理区分</th>
          <td mat-cell *matCellDef="let row">{{row.pressmanagementdivisionAname}} </td>
        </ng-container>
        <ng-container matColumnDef="totalsummaryAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 90px;">
            合算／まとめ</th>
          <td mat-cell *matCellDef="let row">{{ row.totalsummaryAname }}</td>
        </ng-container>
        <ng-container matColumnDef="nrcptMny">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 105px;">
            未入金額[円]</th>
          <td mat-cell *matCellDef="let row" class="text-right">{{ row.nrcptMny| number}}</td>
        </ng-container>
        <ng-container matColumnDef="companyAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 130px;">
            会社</th>
          <td mat-cell *matCellDef="let row">{{row.companyAname}}</td>
        </ng-container>
        <ng-container matColumnDef="areaAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 45px;">地区
          </th>
          <td mat-cell *matCellDef="let row">{{row.areaAname}}</td>
        </ng-container>
        <ng-container matColumnDef="koufuYearmonthdate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 90px;">
            督促管理区分<br>変更年月日</th>
          <td mat-cell *matCellDef="let row">{{row.koufuYearmonthdate | dateString}} </td>
        </ng-container>
        <ng-container matColumnDef="pressmanagementdivisionKirikaersnAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 140px;">
            督促管理区分<br>切替理由</th>
          <td mat-cell *matCellDef="let row">{{row.pressmanagementdivisionKirikaersnAname}}</td>
        </ng-container>
        <ng-container matColumnDef="pressStsAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 140px;">
            督促ステータス</th>
          <td mat-cell *matCellDef="let row">{{row.pressStsAname}}</td>
        </ng-container>
        <ng-container matColumnDef="effectCtrUmu">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 90px;">
            有効契約有無</th>
          <td mat-cell *matCellDef="let row">{{ row.effectCtrUmu }}</td>
        </ng-container>
        <ng-container matColumnDef="chargedivisionAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 115px;">
            料金区分</th>
          <td mat-cell *matCellDef="let row">{{row.chargedivisionAname}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsCol" class="clickable-mat-row"
          (dblclick)="onDblClickRow(row)"></tr>
      </table>
    </div>
    <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>
  </mat-card-content>
</mat-card>